import { render, staticRenderFns } from "./recordDialog.vue?vue&type=template&id=b98f3bc4&"
import script from "./recordDialog.vue?vue&type=script&lang=js&"
export * from "./recordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports